export const POST_SUPPORT_PROCESS = "POST_SUPPORT_PROCESS";
export const POST_SUPPORT_START = "POST_SUPPORT_START";
export const POST_SUPPORT_SUCCESS = "POST_SUPPORT_SUCCESS";
